<!-- 面包屑 -->
<template>
  <div class="bread-crumb">
    <el-breadcrumb separator="/">
      <el-breadcrumb-item v-for="(item, index) in list" :key="index">{{item.title}}</el-breadcrumb-item>
    </el-breadcrumb>
  </div>
</template>

<script type="text/ecmascript-6">
export default {
  computed: {
    list () {
      // console.log(this.$route.matched)
      const list = []
      this.$route.matched.forEach(item => {
        item.path &&
          list.push({
            path: item.path,
            name: item.name,
            title: item.meta.title
          })
      })
      return list
    }
  }
}
</script>

<style scoped lang="scss">
.bread-crumb {
  line-height: 40px;
  height: 40px;
  display: flex;
  align-items: center;
}
</style>

<vue-filename-injector>
export default function (Component) {
  Component.options.__source = "src/layout/header-aside/components/bread-crumb/index.vue"
}
</vue-filename-injector>
